<template>


 <div class="md-input" :class="{'has-errors': hasErrors}" >

        <input
            v-validate="validate"
            :name="inputId"
            :id="inputId"
            :type="inputType"
            class="form-control"
            :class="{'has-value': hasValue}"
            :value="value"
            :ref="inputId"
            @input="$emit('input', $event.target.value)" />


        <label :for="inputId">{{ label }}</label>
        <transition name="fade">
            <div class="error-msg">{{ errors.first(inputId) }}</div>
        </transition>
  </div>


</template>

<script>
export default {
    name: 'InputMaterialWrap',
    inject: ['$validator'],
    props: {
        label: {
            type: String,
            required: true
        },
        inputId: {
            type: String,
            required: true
        },
        inputType:{
            type: String,
            default: 'text'
        },
        value: {
            required: true
        },
        validate: {

        }
    },
    data(){
        return {
            val: this.value
        }
    },
    computed: {
        hasErrors(){
            if(this.fields[this.inputId]){
                if(this.fields[this.inputId].dirty){
                    if(this.fields[this.inputId].invalid){
                        return true
                    }else{
                        return false
                    }
                }else{
                    return false
                }

            }else{
                return false
            }
        },
        hasValue(){
            return this.value != ""
        }
    }
}
</script>

<style lang="scss">
.md-input{
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 15px;
    margin-top: 20px;
    position: relative;
    &.big_input{
        margin-top: 50px;
        input{
            // height: 80px;
            outline: none;
            font-size: 3rem;
            text-align: center;
            font-weight: 200;
            padding-bottom: 10px!important;
            height: 50px;
        }
    }
    input {
      position: relative;
      display: block;
      width: 100%;
      border: none;
      border-bottom: 2px solid $info;
      background-color: transparent;
      margin: 0px auto;
      padding: 0px 0px 0px 0px!important;
      height: 40px;
      outline: none !important;
      font-size: 1.35rem;
      color: $grey-light;
      background-position: left bottom;
      background-size: 0 1px;
      background-repeat: no-repeat;
      transition: all .2s ease-in-out;
        &:focus {
          background-position: left bottom;
          background-size: 100% 1px;
          border-color: $info;
        }
        // &.valid{
        //     border-color: $success;
        // }
        &.has-value + label{
            height: 20px;
            line-height: 20px;
            font-size: 11px;
            color: $grey;
        }
        &:focus + label {
          height: 20px;
          line-height: 20px;
          font-size: 11px;
          color: $info;
        }
    }

    label {
      position: absolute;
      top: -15px;
      left: 0;
      text-align: left;
      display: block;
      width: 100%;
      height: 52px;
      line-height: 72px;
      text-transform: uppercase;
      font-size: 13px;
      font-weight: 600;
      background: transparent;
      color: $grey;
      margin: 0px auto;
      cursor: text;
      transition: all .15s ease-in-out;
    }
    &.has-errors{
        input{
            border-color: $danger;
            &:focus + label{
                color: $danger;
            }
        }
        label{
            color: $danger!important;
        }
    }
    .error-msg{
        transition: .3s all;
        height: 22px;
        font-size: .9rem;
        color: $danger;
    }

}
</style>